export const FULL_NAME_COLUMN_WIDTH = 280
export const EMPLOYEE_MATCH_SELECTOR = 260
export const FULL_NAME_COLUMN_TOKEN_WIDTH = 's360'
